var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "faq" },
    [
      _c(
        "v-collapse-group",
        _vm._l(_vm.faqData, function(item, index) {
          return _c(
            "v-collapse-wrapper",
            {
              key: index,
              staticClass: "last:border-none border-b border-gray-100"
            },
            [
              _c("p", {
                directives: [
                  { name: "collapse-toggle", rawName: "v-collapse-toggle" }
                ],
                staticClass:
                  "header text-14 text-dark no-select py-24 pr-40 font-medium leading-tight",
                domProps: { innerHTML: _vm._s(item.title.rendered) },
                on: { click: _vm.headerClick }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    { name: "collapse-content", rawName: "v-collapse-content" }
                  ],
                  staticClass: "content"
                },
                [
                  _c("p", {
                    staticClass: "text-14 text-blue opacity-70 mb-0",
                    domProps: { innerHTML: _vm._s(item.acf.answer) }
                  })
                ]
              )
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }